import React from 'react';
import ReactDOM from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';
import { Provider } from 'react-redux';
import { store } from './redux/store';
import "@fontsource/inter";
import "@fontsource/inter/500.css";
import "@fontsource/inter/600.css";
import "@fontsource/inter/700.css";
import "@fontsource/outfit";
import "@fontsource/outfit/600.css";
import "@fontsource/outfit/700.css";
import "@fontsource/outfit/800.css";
import './index.css';
import App from './App';
import ErrorBoundary from './components/ErrorBoundary';
import { ColorModeProvider } from './theme/ColorModeContext';
import { NotificationProvider } from './contexts/NotificationProvider';
import { FeatureFlagsProvider } from './contexts/FeatureFlagsProvider';
import reportWebVitals from './reportWebVitals';
import * as serviceWorkerRegistration from './serviceWorkerRegistration';

// Last-resort safety net: any promise rejection that escaped a component's own
// try/catch (the axios interceptor already toasts API errors, but a stray
// non-API rejection would otherwise surface as an uncaught console error and,
// under some setups, break the tab). Swallow it quietly after logging so the
// admin session stays usable.
window.addEventListener('unhandledrejection', (event) => {
  console.error('Unhandled promise rejection (admin kept alive):', event.reason);
  event.preventDefault();
});

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <ErrorBoundary>
      <Provider store={store}>
        <ColorModeProvider>
          <NotificationProvider>
            <BrowserRouter>
              <FeatureFlagsProvider>
                <App />
              </FeatureFlagsProvider>
            </BrowserRouter>
          </NotificationProvider>
        </ColorModeProvider>
      </Provider>
    </ErrorBoundary>
  </React.StrictMode>
);

// Register the PWA service worker so the admin is installable + offline-capable.
// On a new deploy, broadcast an event so the in-app prompt can offer a reload.
serviceWorkerRegistration.register({
  onUpdate: (registration) => {
    window.dispatchEvent(new CustomEvent('pwa:update-available', { detail: registration }));
  },
});

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
